import React from "react";
import { CONFIG } from "../../config/keys";
import axios from "axios";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

class MenuForm extends React.Component {
  render() {
    const updateGroup = formValues => {
      let updatedata = "";
      updatedata = updatedata + `{`;
      if (formValues.Media) {
        updatedata =
          updatedata +
          `${formValues.Section}@odata.bind: "MenuItems(${parseInt(
            formValues.Media
          )})",`;
      }
      updatedata =
        updatedata + `SubscriptionId: "${formValues.SubscriptionId}"`;
      updatedata = updatedata + `}`;
      //console.log(updatedata);

      // ***********************
      // UPDATE RECORD
      const EditQuery = "/Menu(" + parseInt(formValues.Oid) + ")";
      axios({
        method: "put",
        url: CONFIG.API_URL + EditQuery,
        data: updatedata,
        headers: {
          "Content-Type": "application/json",
          Auth: CONFIG.API_KEY
        }
      })
        .then(result => {
          this.props.handleCloseReload();
        })
        .catch(error => console.log(error));
    };
    const renderMediaOptions = () => {
      if (this.props.menuItems) {
        return this.props.menuItems.map((record, index) => {
          return (
            <option key={"menu-items-" + index} value={record.Oid}>
              {record.Name}
            </option>
          );
        });
      }
    };
    const onSubmit = formValues => {
      // console.log(formValues);
      updateGroup(formValues);
    };
    return (
      <div className="txt-center">
        <h4>Media</h4>
        <form onSubmit={this.props.handleSubmit(onSubmit)}>
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="SubscriptionId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="Section"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <div>
            <label>Select Media</label>
            <Field name="Media" component="select">
              <option value="3">None</option>
              {renderMediaOptions()}
            </Field>
          </div>
          <button className="waves-effect waves-light btn btn-small">
            Submit
          </button>
          &nbsp;
          <button
            type="button"
            className="waves-effect waves-light btn btn-small"
            onClick={this.props.handleClose}
          >
            Cancel
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // **************************
  // FIX REFERENCE LINK FIELDS\
  /*
  let initVals = [];
  if (ownProps.data.MenuItems) {
    initVals.MenuItems = ownProps.data.MenuItems.Oid;
  } else {
    initVals.MenuItems = "3";
  } */

  return {
    initialValues: {
      Oid: ownProps.data.Oid,
      Name: ownProps.data.Name,
      Section: ownProps.section,
      Media: ownProps.selected,
      SubscriptionId: ownProps.SubscriptionId
    }
  };
};

const validate = formValues => {
  const errors = {};

  if (!formValues.Name) {
    errors.Name = "Please select media";
  }

  return errors;
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "MenuForm",
    validate
  })(MenuForm)
);
